import { render, staticRenderFns } from "./AscReportNote.vue?vue&type=template&id=4b1e6508&"
import script from "./AscReportNote.vue?vue&type=script&lang=js&"
export * from "./AscReportNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports